'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/alert/style/css.js
// module id = bdxE
// module chunks = 0